import type { Metadata } from "next"
import Link from "next/link"
import { CheckCircle2, FileText, MessageCircle, Shield } from "lucide-react"

import { Container } from "@/components/layout/container"
import { requireAdmin } from "@/lib/auth/require-admin"

export const metadata: Metadata = {
  title: "Admin",
  description: "Адміністративна панель порталу Кухлик.",
}

const adminCards = [
  {
    title: "Recipe submissions",
    description: "Перегляд і модерація рецептів, які надсилають користувачі.",
    href: "/admin/submissions",
    icon: FileText,
  },
  {
    title: "Reviews",
    description: "Контроль відгуків, перевірка якості та майбутня модерація.",
    href: "/admin/reviews",
    icon: CheckCircle2,
  },
  {
    title: "Comments",
    description: "Питання, уточнення і коментарі користувачів до рецептів.",
    href: "/admin/comments",
    icon: MessageCircle,
  },
]

export default async function AdminPage() {
  const { profile } = await requireAdmin()

  return (
    <>
      <section className="border-b border-neutral-200 bg-gradient-to-b from-emerald-50/50 to-white py-12 sm:py-16">
        <Container className="max-w-5xl">
          <div className="eyebrow">Admin</div>
          <h1 className="mt-4 text-4xl font-semibold leading-tight text-neutral-950 sm:text-5xl">
            Адміністративна зона
          </h1>
          <p className="mt-5 text-base leading-8 text-neutral-700 sm:text-lg">
            Доступ підтверджено. Ви увійшли як{" "}
            <span className="font-medium text-neutral-950">
              {profile.email ?? "admin"}
            </span>
            .
          </p>
        </Container>
      </section>

      <section className="py-12 sm:py-14">
        <Container className="max-w-5xl">
          <div className="mb-8 rounded-[1.75rem] border border-emerald-200 bg-emerald-50/70 p-5">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-emerald-700 shadow-sm">
                <Shield className="h-5 w-5" />
              </div>
              <div>
                <div className="text-base font-semibold text-neutral-950">
                  Admin access active
                </div>
                <div className="text-sm text-neutral-600">
                  Базова серверна перевірка ролі вже працює.
                </div>
              </div>
            </div>
          </div>

          <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
            {adminCards.map((card) => {
              const Icon = card.icon

              return (
                <Link
                  key={card.href}
                  href={card.href}
                  className="grid-card group block"
                >
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-800">
                    <Icon className="h-5 w-5" />
                  </div>

                  <h2 className="text-xl font-semibold text-neutral-950 transition-colors group-hover:text-emerald-700">
                    {card.title}
                  </h2>

                  <p className="mt-3 text-sm leading-7 text-neutral-600">
                    {card.description}
                  </p>
                </Link>
              )
            })}
          </div>
        </Container>
      </section>
    </>
  )
}